import {
  plyr_default,
  require_plyr_min
} from "./chunk.UW2KYD6R.js";
import {
  ae
} from "./chunk.Q25FCJRM.js";
import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  setLink
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.7ANACPIR.js";
import {
  getScrollBarWidth
} from "./chunk.WXNWU2SV.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __commonJS,
  __decorateClass,
  __toESM
} from "./chunk.I4IFG4JG.js";

// node_modules/rangetouch/dist/rangetouch.js
var require_rangetouch = __commonJS({
  "node_modules/rangetouch/dist/rangetouch.js"(exports, module) {
    !function(e2, t) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("RangeTouch", t) : (e2 = e2 || self).RangeTouch = t();
    }(exports, function() {
      "use strict";
      function e2(e3, t2) {
        for (var n3 = 0; n3 < t2.length; n3++) {
          var r4 = t2[n3];
          r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e3, r4.key, r4);
        }
      }
      function t(e3, t2, n3) {
        return t2 in e3 ? Object.defineProperty(e3, t2, { value: n3, enumerable: true, configurable: true, writable: true }) : e3[t2] = n3, e3;
      }
      function n2(e3, t2) {
        var n3 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var r4 = Object.getOwnPropertySymbols(e3);
          t2 && (r4 = r4.filter(function(t3) {
            return Object.getOwnPropertyDescriptor(e3, t3).enumerable;
          })), n3.push.apply(n3, r4);
        }
        return n3;
      }
      function r3(e3) {
        for (var r4 = 1; r4 < arguments.length; r4++) {
          var i3 = null != arguments[r4] ? arguments[r4] : {};
          r4 % 2 ? n2(Object(i3), true).forEach(function(n3) {
            t(e3, n3, i3[n3]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(i3)) : n2(Object(i3)).forEach(function(t2) {
            Object.defineProperty(e3, t2, Object.getOwnPropertyDescriptor(i3, t2));
          });
        }
        return e3;
      }
      var i2 = { addCSS: true, thumbWidth: 15, watch: true };
      function u(e3, t2) {
        return function() {
          return Array.from(document.querySelectorAll(t2)).includes(this);
        }.call(e3, t2);
      }
      var o = function(e3) {
        return null != e3 ? e3.constructor : null;
      }, c = function(e3, t2) {
        return !!(e3 && t2 && e3 instanceof t2);
      }, l = function(e3) {
        return null == e3;
      }, a = function(e3) {
        return o(e3) === Object;
      }, s = function(e3) {
        return o(e3) === String;
      }, f = function(e3) {
        return Array.isArray(e3);
      }, h2 = function(e3) {
        return c(e3, NodeList);
      }, d = s, y = f, b = h2, m = function(e3) {
        return c(e3, Element);
      }, g = function(e3) {
        return c(e3, Event);
      }, p = function(e3) {
        return l(e3) || (s(e3) || f(e3) || h2(e3)) && !e3.length || a(e3) && !Object.keys(e3).length;
      };
      function v(e3, t2) {
        if (1 > t2) {
          var n3 = function(e4) {
            var t3 = "".concat(e4).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            return t3 ? Math.max(0, (t3[1] ? t3[1].length : 0) - (t3[2] ? +t3[2] : 0)) : 0;
          }(t2);
          return parseFloat(e3.toFixed(n3));
        }
        return Math.round(e3 / t2) * t2;
      }
      return function() {
        function t2(e3, n4) {
          (function(e4, t3) {
            if (!(e4 instanceof t3)) throw new TypeError("Cannot call a class as a function");
          })(this, t2), m(e3) ? this.element = e3 : d(e3) && (this.element = document.querySelector(e3)), m(this.element) && p(this.element.rangeTouch) && (this.config = r3({}, i2, {}, n4), this.init());
        }
        return n3 = t2, c2 = [{ key: "setup", value: function(e3) {
          var n4 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, o3 = null;
          if (p(e3) || d(e3) ? o3 = Array.from(document.querySelectorAll(d(e3) ? e3 : 'input[type="range"]')) : m(e3) ? o3 = [e3] : b(e3) ? o3 = Array.from(e3) : y(e3) && (o3 = e3.filter(m)), p(o3)) return null;
          var c3 = r3({}, i2, {}, n4);
          if (d(e3) && c3.watch) {
            var l2 = new MutationObserver(function(n5) {
              Array.from(n5).forEach(function(n6) {
                Array.from(n6.addedNodes).forEach(function(n7) {
                  m(n7) && u(n7, e3) && new t2(n7, c3);
                });
              });
            });
            l2.observe(document.body, { childList: true, subtree: true });
          }
          return o3.map(function(e4) {
            return new t2(e4, n4);
          });
        } }, { key: "enabled", get: function() {
          return "ontouchstart" in document.documentElement;
        } }], (o2 = [{ key: "init", value: function() {
          t2.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(true), this.element.rangeTouch = this);
        } }, { key: "destroy", value: function() {
          t2.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(false), this.element.rangeTouch = null);
        } }, { key: "listeners", value: function(e3) {
          var t3 = this, n4 = e3 ? "addEventListener" : "removeEventListener";
          ["touchstart", "touchmove", "touchend"].forEach(function(e4) {
            t3.element[n4](e4, function(e5) {
              return t3.set(e5);
            }, false);
          });
        } }, { key: "get", value: function(e3) {
          if (!t2.enabled || !g(e3)) return null;
          var n4, r4 = e3.target, i3 = e3.changedTouches[0], u2 = parseFloat(r4.getAttribute("min")) || 0, o3 = parseFloat(r4.getAttribute("max")) || 100, c3 = parseFloat(r4.getAttribute("step")) || 1, l2 = r4.getBoundingClientRect(), a2 = 100 / l2.width * (this.config.thumbWidth / 2) / 100;
          return 0 > (n4 = 100 / l2.width * (i3.clientX - l2.left)) ? n4 = 0 : 100 < n4 && (n4 = 100), 50 > n4 ? n4 -= (100 - 2 * n4) * a2 : 50 < n4 && (n4 += 2 * (n4 - 50) * a2), u2 + v(n4 / 100 * (o3 - u2), c3);
        } }, { key: "set", value: function(e3) {
          t2.enabled && g(e3) && !e3.target.disabled && (e3.preventDefault(), e3.target.value = this.get(e3), function(e4, t3) {
            if (e4 && t3) {
              var n4 = new Event(t3, { bubbles: true });
              e4.dispatchEvent(n4);
            }
          }(e3.target, "touchend" === e3.type ? "change" : "input"));
        } }]) && e2(n3.prototype, o2), c2 && e2(n3, c2), t2;
        var n3, o2, c2;
      }();
    });
  }
});

// node_modules/simple-scrollbar-reworked/simple-scrollbar.js
var require_simple_scrollbar = __commonJS({
  "node_modules/simple-scrollbar-reworked/simple-scrollbar.js"(exports, module) {
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = factory(window, document);
      } else {
        root.SimpleScrollbar = factory(window, document);
      }
    })(exports, function(w, d) {
      var raf = w.requestAnimationFrame || w.setImmediate || function(c) {
        return setTimeout(c, 0);
      };
      function initEl(el) {
        if (Object.prototype.hasOwnProperty.call(el, "data-simple-scrollbar")) return;
        Object.defineProperty(el, "data-simple-scrollbar", { value: new SimpleScrollbar2(el) });
      }
      function dragDealer(el, context) {
        var lastPageY;
        el.addEventListener("mousedown", function(e2) {
          lastPageY = e2.pageY;
          el.classList.add("ss-grabbed");
          d.body.classList.add("ss-grabbed");
          d.addEventListener("mousemove", drag);
          d.addEventListener("mouseup", stop);
          return false;
        });
        function drag(e2) {
          var delta = e2.pageY - lastPageY;
          lastPageY = e2.pageY;
          raf(function() {
            context.el.scrollTop += delta / context.scrollRatio;
          });
        }
        function stop() {
          el.classList.remove("ss-grabbed");
          d.body.classList.remove("ss-grabbed");
          d.removeEventListener("mousemove", drag);
          d.removeEventListener("mouseup", stop);
        }
      }
      function ss(el) {
        this.target = el;
        this.direction = w.getComputedStyle(this.target).direction;
        this.bar = '<div class="ss-scroll">';
        this.wrapper = d.createElement("div");
        this.wrapper.setAttribute("class", "ss-wrapper");
        this.el = d.createElement("div");
        this.el.setAttribute("class", "ss-content");
        this.track = d.createElement("div");
        this.track.setAttribute("class", "ss-track");
        if (this.direction === "rtl") {
          this.el.classList.add("rtl");
        }
        this.wrapper.appendChild(this.el);
        while (this.target.firstChild) {
          this.el.appendChild(this.target.firstChild);
        }
        this.target.appendChild(this.wrapper);
        this.target.appendChild(this.track);
        this.track.insertAdjacentHTML("beforeend", this.bar);
        this.bar = this.track.lastChild;
        dragDealer(this.bar, this);
        this.moveBar();
        w.addEventListener("resize", this.moveBar.bind(this));
        this.el.addEventListener("scroll", this.moveBar.bind(this));
        this.el.addEventListener("mouseenter", this.moveBar.bind(this));
        this.target.classList.add("ss-container");
        var css = w.getComputedStyle(el);
        if (css["height"] === "0px" && css["max-height"] !== "0px") {
          el.style.height = css["max-height"];
        }
      }
      ss.prototype = {
        moveBar: function(e2) {
          var totalHeight = this.el.scrollHeight, ownHeight = this.el.clientHeight, _this = this;
          this.scrollRatio = ownHeight / totalHeight;
          raf(function() {
            if (_this.scrollRatio >= 1) {
              _this.track.classList.add("ss-hidden");
            } else {
              _this.track.classList.remove("ss-hidden");
              _this.bar.style.cssText = "height:" + Math.max(_this.scrollRatio * 100, 10) + "%; top:" + _this.el.scrollTop / totalHeight * 100 + "%;";
            }
          });
        }
      };
      function initAll() {
        var nodes = d.querySelectorAll("*[ss-container]");
        for (var i2 = 0; i2 < nodes.length; i2++) {
          initEl(nodes[i2]);
        }
      }
      d.addEventListener("DOMContentLoaded", initAll);
      ss.initEl = initEl;
      ss.initAll = initAll;
      var SimpleScrollbar2 = ss;
      return SimpleScrollbar2;
    });
  }
});

// src/components/jb-podcast-player/jb-podcast-player.ts
var import_plyr = __toESM(require_plyr_min(), 1);
var import_rangetouch = __toESM(require_rangetouch(), 1);
var import_simple_scrollbar_reworked = __toESM(require_simple_scrollbar(), 1);

// node_modules/simple-scrollbar-reworked/simple-scrollbar.scss?inline
var simple_scrollbar_default = i`.ss-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  float: left;
}

.ss-content {
  height: 100%;
  width: calc(100% + 18px);
  padding: 0 0 0 0;
  position: relative;
  overflow: auto;
  box-sizing: border-box;
}

.ss-content.rtl {
  width: calc(100% + 18px);
  right: auto;
}

.ss-scroll {
  position: relative;
  background: rgba(0, 0, 0, 0.1);
  width: 9px;
  border-radius: 4px;
  top: 0;
  right: 0;
  z-index: 2;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.25s linear;
}

.ss-track {
  max-height: 100px;
  position: absolute;
  border-radius: 4px;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  width: 9px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.ss-hidden {
  display: none;
}

.ss-container:hover .ss-scroll,
.ss-container:active .ss-scroll {
  opacity: 1;
}

.ss-grabbed {
  -o-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}`;

// src/components/jb-podcast-player/jb-podcast-player.scss?inline
var jb_podcast_player_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.playlist .headline, .playlist .duration, .playlist .date {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

header.main h2, .plyr--audio > .plyr__controls, .playlist .description, header.main p, footer span {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.playlist .duration, .playlist .date {
  font-size: var(--theme-typo-uppercase-700-fontsize, 0.688rem);
  letter-spacing: var(--theme-typo-uppercase-700-letterspacing, 0.063rem);
  line-height: var(--theme-typo-uppercase-700-lineheight, 1rem);
  text-transform: uppercase;
}

footer span {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

.playlist .headline {
  font-size: var(--theme-typo-p-small-highlight-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-highlight-desktop-lineheight, 1.625rem);
}

.plyr--audio > .plyr__controls, .playlist .description, header.main p {
  font-size: var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-desktop-lineheight, 1.25rem);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --_shadow-down: 0px 8px 14px 0px rgba(161, 160, 172, 0.17);
  --_shadow-up: 0px -8px 14px 0px rgba(161, 160, 172, 0.17);
  --_playlist-height: 460px;
  --_thumb-height: 10px;
  --_thumb-width: 2px;
  --_track-height: 6px;
  --_range-color: 255 255 255;
  background-color: white;
  border: 1px solid rgba(20, 30, 85, var(--theme-opacity-40, 0.4));
  display: block;
}

header.main {
  align-items: center;
  display: flex;
  gap: var(--spacing-2xs);
  padding: var(--spacing-2xs) var(--spacing-sm);
}
@media (min-width: 600px) {
  header.main {
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) var(--spacing-m) var(--spacing-s);
  }
}
header.main.scrolledtop {
  box-shadow: var(--_shadow-down);
}
header.main jb-picture {
  width: 40px;
}
@media (min-width: 600px) {
  header.main jb-picture {
    width: 100px;
  }
}
header.main > div {
  flex: 1;
  overflow: hidden;
}
header.main h2 {
  font-size: 1.188rem;
  line-height: 1.75rem;
  margin-bottom: var(--spacing-base);
}
@media (min-width: 600px) {
  header.main h2 {
    font-size: 1.625rem;
    line-height: 2.188rem;
  }
}
@media (min-width: 1281px) {
  header.main h2 {
    font-size: 1.938rem;
    line-height: 2.625rem;
  }
}
header.main p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 600px) {
  header.main p {
    font-size: 1rem;
    line-height: 1.625rem;
    white-space: normal;
  }
}

ul {
  list-style: none;
}

.playlist {
  display: block;
  height: var(--_playlist-height);
  overflow: auto;
  position: relative;
  --_scrollbar-margin: 5px;
}
.playlist.ss-container {
  overflow: unset;
}
.playlist .ss-track {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  bottom: var(--_scrollbar-margin);
  height: auto;
  max-height: calc(100% - 2 * var(--_scrollbar-margin));
  right: var(--spacing-3xs);
  top: var(--_scrollbar-margin);
  transform: none;
}
.playlist .ss-scroll {
  background-color: rgba(20, 30, 85, var(--theme-opacity-40, 0.4));
  border-radius: 100vh;
  cursor: default;
  width: 6px;
}
.playlist li:not(:first-child) {
  border-top: 1px solid rgba(20, 30, 85, var(--theme-opacity-40, 0.4));
}
.playlist li {
  box-sizing: border-box;
  padding: var(--spacing-3xs) var(--spacing-sm);
  transition: background-color 0.3s ease-in-out;
  width: calc(100% - var(--_scrollbar-width, 0));
}
@media (min-width: 600px) {
  .playlist li {
    padding: var(--spacing-2xs) var(--spacing-m) var(--spacing-xs);
  }
}
.playlist li[data-playing] .isplaying {
  display: flex;
}
.playlist li[data-playing] .ispaused {
  display: none;
}
.playlist li[data-active] .progress {
  opacity: 1;
}
.playlist li:hover {
  background-color: #f1f2f2;
}
.playlist li:hover .accordiontoggle {
  opacity: 1;
  translate: 0 2px;
}
.playlist li:hover .progress input {
  --_thumb-height: 10px;
  --_track-height: 6px;
  --_track-top: -2px;
}
.playlist li:hover .playbackbutton {
  outline-offset: 0;
}
.playlist li:hover .playbackbutton svg {
  scale: 1;
}
.playlist details + .description {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease-in-out;
}
.playlist details[open] + .description {
  grid-template-rows: 1fr;
}
.playlist details[open] + .description > div {
  padding-top: var(--spacing-3xs);
  transition: padding-top 0.3s ease-in-out;
}
.playlist summary {
  align-items: center;
  cursor: pointer;
  display: grid;
  gap: var(--spacing-base);
  grid-template-columns: 1fr;
}
@media (min-width: 600px) {
  .playlist summary {
    gap: var(--spacing-s);
    grid-template-columns: 1fr 215px;
  }
}
.playlist summary::-webkit-details-marker {
  display: none;
}
.playlist .accordiontoggle {
  height: 18px;
  opacity: 0.4;
  rotate: 90deg;
  transition: translate 0.3s ease-in-out, rotate 0.3s ease-in-out, opacity 0.3s ease-in-out;
  width: 18px;
}
.playlist details[open] .accordiontoggle {
  rotate: -90deg;
}
.playlist .info {
  flex-shrink: 1;
}
.playlist .date {
  color: rgba(20, 30, 85, var(--theme-opacity-70, 0.7));
}
.playlist .info .date {
  display: none;
}
@media (min-width: 600px) {
  .playlist .info .date {
    display: inline-block;
  }
}
.playlist .control .date {
  display: inline-block;
  flex: 1;
  margin-right: var(--spacing-xs);
}
@media (min-width: 600px) {
  .playlist .control .date {
    display: none;
  }
}
.playlist .duration {
  color: rgba(20, 30, 85, var(--theme-opacity-70, 0.7));
  margin-right: var(--spacing-xs);
  text-align: right;
  width: 50px;
}
.playlist .control {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.playlist .headline {
  text-wrap: balance;
}
.playlist .description > div {
  overflow: hidden;
  padding-top: 0;
  transition: padding-top 0.3s ease-in-out;
}
.playlist .progress {
  display: inline-flex;
  flex: 1;
  margin-right: var(--spacing-3xs);
  max-width: 81px;
  opacity: 0;
  position: relative;
}
.playlist .playbackbutton {
  --_spinner-color: 20 30 85;
  align-items: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 26px;
  justify-content: center;
  margin-right: var(--spacing-xs);
  outline: 1px solid #141e55;
  outline-offset: -1px;
  padding: 0;
  position: relative;
  transition: outline-offset 0.1s ease-in-out;
  width: 26px;
}
.playlist .playbackbutton > div {
  display: flex;
}
.playlist .playbackbutton > .isplaying {
  display: none;
}
.playlist .playbackbutton > .ispaused {
  display: flex;
}
.playlist .playbackbutton svg {
  height: 12px;
  scale: 0.8;
  transition: scale 0.1s ease-in-out;
  width: 100%;
}

.bottom {
  position: relative;
}

.scrolledbottom {
  box-shadow: var(--_shadow-up);
}

#player {
  --_spinner-color: 255 255 255;
  left: 0;
  position: absolute;
  top: 0;
  transition: top 0.3s ease-in-out;
  width: 100%;
  z-index: 1;
}

[data-playeropen] .playlist .ss-content {
  padding-bottom: var(--playerheight, 60px);
}
[data-playeropen] #player {
  top: calc(-1 * var(--playerheight, 60px));
}

footer {
  align-items: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3xs);
  justify-content: center;
  padding: var(--spacing-3xs) var(--spacing-sm) var(--spacing-2xs);
  position: relative;
  z-index: 2;
}
@media (min-width: 600px) {
  footer {
    flex-direction: row;
    justify-content: space-between;
    padding: var(--spacing-s) var(--spacing-m);
  }
}
footer span {
  color: rgba(20, 30, 85, var(--theme-opacity-80, 0.8));
}
footer jb-picture {
  max-width: 150px;
}
footer ul {
  display: flex;
  gap: var(--spacing-xs);
}
footer li {
  flex: 1;
}

.plyr--audio > .plyr__controls {
  background-color: #141e55;
  color: white;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  gap: var(--spacing-base);
  justify-content: space-between;
  padding: var(--spacing-3xs) var(--spacing-sm) var(--spacing-2xs);
}
@media (min-width: 600px) {
  .plyr--audio > .plyr__controls {
    flex-direction: row;
    gap: var(--spacing-s);
    padding: var(--spacing-xs) var(--spacing-m);
  }
}
.plyr--audio > .plyr__controls .control {
  align-items: center;
  display: flex;
  gap: var(--spacing-2xs);
  justify-content: flex-end;
  width: 100%;
}
@media (min-width: 600px) {
  .plyr--audio > .plyr__controls .control {
    width: auto;
  }
}
.plyr--audio > .plyr__controls .title {
  text-align: left;
  width: 100%;
}
@media (min-width: 600px) {
  .plyr--audio > .plyr__controls .title {
    width: auto;
  }
  .plyr--audio > .plyr__controls .title::after {
    color: rgba(255, 255, 255, 0.7);
    content: " - " var(--podcastdate, "");
    display: inline;
    font-weight: 300;
    margin-left: var(--spacing-base);
    white-space: nowrap;
  }
}
.plyr--audio > .plyr__controls .plyr__time,
.plyr--audio > .plyr__controls .duration {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 300;
}

.plyr--audio .plyr__control:focus-visible,
.plyr--audio .plyr__control:hover,
.plyr--audio .plyr__control[aria-expanded=true] {
  background-color: transparent;
}

.plyr__control {
  border-radius: 0;
}
.plyr__control[data-plyr=play] {
  outline: 1px solid white;
  outline-offset: -1px;
}

.volume__control {
  display: none;
  position: relative;
  --_range-color: 20, 30, 85;
  --_track-height: 2px;
}
@media (min-width: 600px) {
  .volume__control {
    display: block;
  }
}
.volume__control .plyr__control {
  background-color: transparent;
  border: 0;
}
.volume__control .plyr__volume {
  background-color: white;
  box-shadow: var(--_shadow-down);
  display: none;
  left: 16px;
  padding: 8px;
  position: absolute;
  top: -1.5rem;
  transform: rotate(-90deg);
  transform-origin: left center;
}
.volume__control .plyr__volume::after {
  border: 6px solid transparent;
  border-image: initial;
  border-right-color: white;
  bottom: 11px;
  content: "";
  display: block;
  left: -11px;
  position: absolute;
}

.volume__control:hover .plyr__volume,
.volume__control:active .plyr__volume {
  display: block;
}

.plyr--audio {
  --_thumb-height: 2px;
  --_track-height: 2px;
  --_track-top: 4px;
}
.plyr--audio:hover {
  --_thumb-height: 10px;
  --_track-height: 6px;
  --_track-top: 2px;
}
.plyr--audio:hover [data-plyr=play] {
  outline-offset: 0;
}
.plyr--audio:hover [data-plyr=play] svg {
  scale: 1;
}
.plyr--audio .plyr__progress {
  flex: 1;
  max-width: 70px;
  order: -1;
  transition: max-width 0.3s ease-in-out;
}
@media (min-width: 600px) {
  .plyr--audio .plyr__progress {
    flex: unset;
    order: unset;
  }
}
.plyr--audio.plyr--paused .plyr__time--current {
  display: none;
}
.plyr--audio.plyr--playing .plyr__time--current {
  display: inline-block;
}
.plyr--audio.plyr--playing .plyr__time--duration {
  display: none;
}
@media (min-width: 600px) {
  .plyr--audio.plyr--playing .plyr__time--duration {
    display: inline-block;
  }
}
.plyr--audio .control::before {
  color: rgba(255, 255, 255, 0.4);
  content: var(--podcastdate);
  display: inline-block;
  flex: 1;
  margin-right: var(--spacing-2xs);
  order: -1;
  text-align: left;
  text-transform: uppercase;
}
@media (min-width: 600px) {
  .plyr--audio .control::before {
    display: none;
  }
}
.plyr--audio:not(.loading) .duration::before {
  content: var(--podcastduration);
  white-space: nowrap;
}
.plyr--audio:not(.loading) .duration > div {
  display: none;
}
.plyr--audio[data-seeking] .control::before, .plyr--audio[data-playing] .control::before {
  display: none;
}
.plyr--audio[data-seeking] .play, .plyr--audio[data-playing] .play {
  display: none;
}
.plyr--audio[data-seeking] .pause, .plyr--audio[data-playing] .pause {
  display: flex;
}
.plyr--audio[data-seeking] .plyr__time--current, .plyr--audio[data-playing] .plyr__time--current {
  display: inline-block;
}
.plyr--audio[data-seeking] .plyr__progress, .plyr--audio[data-playing] .plyr__progress {
  max-width: 100%;
}
.plyr--audio[data-seeking] .duration::before, .plyr--audio[data-playing] .duration::before {
  display: none;
}
@media (min-width: 600px) {
  .plyr--audio[data-seeking] .duration > div, .plyr--audio[data-playing] .duration > div {
    display: block;
  }
}
.plyr--audio .play {
  display: flex;
}
.plyr--audio .pause {
  display: none;
}
.plyr--audio [data-plyr=play] {
  aspect-ratio: 1;
  outline-offset: -1px;
  transition: outline-offset 0.1s ease-in-out;
}
.plyr--audio [data-plyr=play] svg {
  scale: 0.8;
  transition: scale 0.1s ease-in-out;
}

.playlist input[type=range] {
  --_range-color: 20 30 85;
  --_thumb-height: 2px;
  --_track-height: 2px;
  --_track-top: 0px;
  appearance: none;
  background: transparent;
  width: 100%;
}
.playlist input[type=range]::-webkit-slider-runnable-track {
  background-color: rgb(var(--_range-color)/0.2);
}
.playlist input[type=range]::-webkit-slider-thumb {
  appearance: none;
  background-color: rgb(var(--_range-color));
  border: 0;
  border-radius: 0;
  box-shadow: none;
  height: var(--_thumb-height);
  position: relative;
  top: var(--_track-top);
  width: var(--_thumb-width);
}
.playlist input[type=range]::-moz-range-track {
  background-color: rgb(var(--_range-color)/0.2);
  height: var(--_track-height);
}
.playlist input[type=range]::-moz-range-progress {
  background: currentcolor;
  background-color: rgb(var(--_range-color));
  height: 2px;
  position: relative;
}

.plyr--full-ui .volume__control input[type=range]::-webkit-slider-thumb {
  top: 0;
}

.playlist input[type=range]:active::-moz-range-thumb,
.plyr--full-ui.plyr--audio input[type=range]:active::-moz-range-thumb {
  box-shadow: none;
}

.playlist input[type=range]::-moz-range-progress,
.plyr--full-ui input[type=range]::-moz-range-progress {
  background-color: rgb(var(--_range-color));
  border-radius: 0;
  height: var(--_track-height);
}

.playlist input[type=range]::-moz-range-thumb,
.plyr--full-ui input[type=range]::-moz-range-thumb {
  background-color: rgb(var(--_range-color));
  border: 0;
  border-radius: 0;
  box-shadow: none;
  height: var(--_thumb-height);
  margin-top: 0;
  width: var(--_thumb-width);
}

.playlist input[type=range]::-moz-range-track,
.plyr--full-ui.plyr--audio input[type=range]::-moz-range-track {
  border-radius: 0;
}

.plyr--full-ui input[type=range]::-moz-range-track {
  background-color: transparent;
  box-shadow: none;
  height: var(--_track-height);
  transition: none;
}

.playlist input[type=range]:active::-webkit-slider-thumb,
.plyr--full-ui.plyr--audio input[type=range]:active::-webkit-slider-thumb {
  box-shadow: none;
}

.plyr--full-ui input[type=range]::-webkit-slider-thumb {
  background-color: rgb(var(--_range-color));
  border: 0;
  border-radius: 0;
  box-shadow: none;
  height: var(--_thumb-height);
  top: var(--_track-top);
  transition: none;
  width: var(--_thumb-width);
}

.playlist input[type=range]::-webkit-slider-runnable-track,
.plyr--full-ui input[type=range]::-webkit-slider-runnable-track {
  background-image: linear-gradient(to right, currentcolor var(--value, 0%), transparent var(--value, 0%));
  border-radius: 0;
  color: rgb(var(--_range-color));
  height: var(--_track-height);
  user-select: none;
}

.loading::after {
  animation: 1.5s linear 0s infinite normal none running spin;
  border-color: rgb(var(--_spinner-color)) rgb(var(--_spinner-color)/0.3) rgb(var(--_spinner-color)/0.3);
  border-radius: 100vh;
  border-style: solid;
  border-width: 2px;
  content: "";
  display: block;
  inset: 4px;
  position: absolute;
}

@keyframes spin {
  to {
    rotate: 360deg;
  }
}`;

// src/components/jb-podcast-player/jb-podcast-player.ts
var JbPodcastPlayer = class extends ChangesBackgroundColor(Spaceable(h)) {
  constructor() {
    super(...arguments);
    this._currentProgress = 0;
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this._sendTracking("visible", { file_progress: "visible" });
          this._observer.unobserve(this);
          this._observer.disconnect();
        }
      });
    });
    this._pauseIcon = ke`<svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.35"
      y="2"
      width="2.3"
      height="14"
      rx=".245"
    ></rect>
    <rect
      x="11.35"
      y="2"
      width="2.3"
      height="14"
      rx=".245"
    ></rect>
  </svg>`;
    this._playerOpen = false;
    this._playIcon = ke`<svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.308 9.192l-6.345 6.345a.271.271 0 01-.463-.192V2.655a.271.271 0 01.463-.192l6.345 6.345a.271.271 0 010 .384z"
    ></path>
  </svg>`;
    this._playingUrl = "";
  }
  async firstUpdated() {
    let scrollContainer;
    if (getScrollBarWidth() !== 0) {
      import_simple_scrollbar_reworked.default.initEl(this._playlist);
      await this.updateComplete;
      scrollContainer = this.shadowRoot.querySelector(".ss-content");
    } else {
      scrollContainer = this._playlist;
    }
    scrollContainer.addEventListener("scroll", this._playlistScrolled.bind(this));
    const controls = `
  <div class="plyr__controls">
    <div class="title">{title}</div>
    <div class="control">
      <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
      <div class="plyr__progress">
          <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
          <span role="tooltip" class="plyr__tooltip">00:00</span>
      </div>
      <div class="duration">
        <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
      </div>
      <div class="volume__control">
        <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
            <svg class="icon--pressed" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0354 18.8662C10.1524 18.953 10.2963 19 10.4443 19C10.8125 19 11.111 18.7148 11.111 18.3631V2.65205C11.1171 2.40617 10.9745 2.17891 10.7446 2.06819C10.5147 1.95747 10.2387 1.9831 10.0354 2.13401L4.76569 6.04903H0.666662C0.298475 6.04903 0 6.33419 0 6.68596V14.5415C0 14.8932 0.298475 15.1784 0.666662 15.1784H4.88886C4.93845 15.1784 4.98678 15.1732 5.03329 15.1634L10.0354 18.8662ZM5.55552 7.08294V13.9322L9.77766 17.068V3.94715L5.55552 7.08294ZM1.33332 7.32289H4.22214V13.9045H1.33332V7.32289ZM14.6672 15.9257C14.3564 15.926 14.0866 15.7209 14.017 15.4315C13.9474 15.142 14.0964 14.845 14.3761 14.7156C16.0665 13.9365 17.1409 12.3017 17.1409 10.5086C17.1409 8.71554 16.0665 7.08073 14.3761 6.30168C14.1618 6.20231 14.0192 6.00123 14.0021 5.77419C13.985 5.54715 14.0959 5.32863 14.2932 5.20095C14.4904 5.07327 14.744 5.05583 14.9584 5.1552C17.1087 6.1471 18.4752 8.22724 18.4752 10.5086C18.4752 12.79 17.1087 14.8701 14.9584 15.862C14.8676 15.904 14.7681 15.9258 14.6672 15.9257ZM14.0776 12.4682C14.193 12.6762 14.419 12.8065 14.6654 12.8069C14.8904 12.8084 15.101 12.7014 15.2254 12.5224C16.0853 11.3032 16.0853 9.70763 15.2254 8.48848C15.0193 8.19534 14.6034 8.1174 14.2966 8.31439C13.9897 8.51138 13.9082 8.90871 14.1143 9.20185C14.6713 9.99099 14.6713 11.0241 14.1143 11.8133C13.9764 12.0083 13.9622 12.2602 14.0776 12.4682Z" fill="white" fill-opacity="1"/></svg>
            <svg class="icon--not-pressed" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0354 18.8662C10.1524 18.953 10.2963 19 10.4443 19C10.8125 19 11.111 18.7148 11.111 18.3631V2.65205C11.1171 2.40617 10.9745 2.17891 10.7446 2.06819C10.5147 1.95747 10.2387 1.9831 10.0354 2.13401L4.76569 6.04903H0.666662C0.298475 6.04903 0 6.33419 0 6.68596V14.5415C0 14.8932 0.298475 15.1784 0.666662 15.1784H4.88886C4.93845 15.1784 4.98678 15.1732 5.03329 15.1634L10.0354 18.8662ZM5.55552 7.08294V13.9322L9.77766 17.068V3.94715L5.55552 7.08294ZM1.33332 7.32289H4.22214V13.9045H1.33332V7.32289ZM14.6672 15.9257C14.3564 15.926 14.0866 15.7209 14.017 15.4315C13.9474 15.142 14.0964 14.845 14.3761 14.7156C16.0665 13.9365 17.1409 12.3017 17.1409 10.5086C17.1409 8.71554 16.0665 7.08073 14.3761 6.30168C14.1618 6.20231 14.0192 6.00123 14.0021 5.77419C13.985 5.54715 14.0959 5.32863 14.2932 5.20095C14.4904 5.07327 14.744 5.05583 14.9584 5.1552C17.1087 6.1471 18.4752 8.22724 18.4752 10.5086C18.4752 12.79 17.1087 14.8701 14.9584 15.862C14.8676 15.904 14.7681 15.9258 14.6672 15.9257ZM14.0776 12.4682C14.193 12.6762 14.419 12.8065 14.6654 12.8069C14.8904 12.8084 15.101 12.7014 15.2254 12.5224C16.0853 11.3032 16.0853 9.70763 15.2254 8.48848C15.0193 8.19534 14.6034 8.1174 14.2966 8.31439C13.9897 8.51138 13.9082 8.90871 14.1143 9.20185C14.6713 9.99099 14.6713 11.0241 14.1143 11.8133C13.9764 12.0083 13.9622 12.2602 14.0776 12.4682Z" fill="white" fill-opacity="0.7"/></svg>
        </button>
        <div class="plyr__volume">
            <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
        </div>
      </div>
      <button type="button" class="plyr__control" data-plyr="play">
          <svg class="pause" role="presentation"><rect
          x="4.35"
          y="2"
          width="2.3"
          height="14"
          rx=".245"
        ></rect>
        <rect
          x="11.35"
          y="2"
          width="2.3"
          height="14"
          rx=".245"
        ></rect></svg>
          <svg class="play" role="presentation"><path
          d="M13.308 9.192l-6.345 6.345a.271.271 0 01-.463-.192V2.655a.271.271 0 01.463-.192l6.345 6.345a.271.271 0 010 .384z"
        ></path></svg>
          <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
          <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
      </button>
    </div>
  </div>
`;
    this._plyr = new import_plyr.default(this._audioPlayer, {
      controls,
      loadSprite: false,
      i18n: {
        mute: this.ariaLabelMute ?? "Mute",
        pause: this.ariaLabelPause ?? "Pause",
        play: this.ariaLabelPlay ?? "Play",
        seek: this.ariaLabelSeek ?? "Seek",
        volume: this.ariaLabelVolume ?? "Volume"
      }
    });
    this._plyr.on("ready", (evt) => {
      this.style.setProperty("--playerheight", this._plyr.elements.container.offsetHeight + "px");
      const progressBar = evt.detail.plyr.elements.controls.querySelector(".plyr__progress");
      const progressBarRangeInput = progressBar.querySelector('input[type="range"]');
      new import_rangetouch.default(progressBarRangeInput, {});
      progressBar.addEventListener("touchstart", () => {
        evt.detail.plyr.elements.container.setAttribute("data-seeking", "");
      });
      progressBar.addEventListener("touchend", () => {
        evt.detail.plyr.elements.container.removeAttribute("data-seeking");
      });
      progressBar.addEventListener("mousedown", () => {
        evt.detail.plyr.elements.container.setAttribute("data-seeking", "");
      });
      progressBar.addEventListener("mouseup", () => {
        evt.detail.plyr.elements.container.removeAttribute("data-seeking");
      });
    });
    this._plyr.on("timeupdate", (evt) => {
      const currentTime = evt.detail.plyr.currentTime || 0;
      const currentDuration = evt.detail.plyr.duration;
      const currentPercentage = currentDuration > 0 ? Math.round(currentTime / currentDuration * 10) * 10 : 0;
      if (currentPercentage > this._currentProgress) {
        this._currentProgress = currentPercentage;
        this._sendTracking("progress", {
          file_progress: this._currentProgress + "%",
          file_type: this._playingUrl.split(".").pop(),
          time_elapsed: Math.round(evt.detail.plyr.currentTime)
        });
      }
      const currentProgress = Math.floor(evt.detail.plyr.currentTime * 100 / evt.detail.plyr.duration);
      if (typeof currentProgress !== "number" || !this._playingElement) return;
      const progressElement = this._playingElement.querySelector(".progress > input");
      progressElement.style.setProperty("--value", Number.isNaN(currentProgress) ? "0" : currentProgress + "%");
      progressElement.value = String(currentProgress);
    });
    this._plyr.on("playing", (evt) => {
      const listPlayButton = this._playingElement.querySelector(".playbackbutton");
      this._playingElement.dataset.playing = "";
      evt.detail.plyr.elements.buttons.play[0].classList.remove("loading");
      evt.detail.plyr.elements.container.setAttribute("data-playing", "");
      listPlayButton.classList.remove("loading");
      listPlayButton.ariaPressed = "true";
      listPlayButton.ariaLabel = this.ariaLabelPause ?? "Pause";
    });
    this._plyr.on("pause", (evt) => {
      evt.detail.plyr.elements.container.removeAttribute("data-playing");
      this._playingElement.removeAttribute("data-playing");
      const listPlayButton = this._playingElement.querySelector(".playbackbutton");
      listPlayButton.ariaPressed = "false";
      listPlayButton.ariaLabel = this.ariaLabelPlay ?? "Play";
    });
    this._plyr.on("loadstart", (evt) => {
      this._playlist.querySelector('[aria-pressed="true"]')?.setAttribute("aria-pressed", "false");
      if (this._playingUrl === "") return;
      this._playingElement.querySelector(".playbackbutton").classList.add("loading");
      const range = this._playingElement.querySelector('[type="range"]');
      range.value = "0";
      evt.detail.plyr.elements.buttons.play[0].classList.add("loading");
    });
    window.addEventListener("resize", () => {
      this.style.setProperty("--playerheight", this._plyr.elements.container.offsetHeight + "px");
    });
    this._observer.observe(this);
  }
  _getContentSpacingProperties() {
    return { grid: "legacy", colsMdUp: 8 };
  }
  _playlistScrolled(evt) {
    const target = evt.currentTarget;
    this._isScrolledTop = target.scrollTop > 0;
    this._isScrolledBottom = target.scrollHeight - (target.scrollTop + target.offsetHeight) === 0;
  }
  _progressSliderChange(evt) {
    const inpt = evt.target;
    inpt.style.setProperty("--value", inpt.value ?? "0%");
  }
  _progressSliderMouseDown() {
    this._plyr.pause();
  }
  _progressSliderMouseUp(evt) {
    const inpt = evt.target;
    this._plyr.currentTime = this._plyr.duration * parseFloat(inpt.value) / 100;
    this._plyr.play();
  }
  _sendTracking(interaction_type, additionalInfo) {
    const trackingDetails = {
      event: "ce_audio",
      event_version: "v2",
      component_name: "podcast-player",
      file_name: this._playingUrl !== "" ? `${this.headline}: ${this._playingElement.dataset.podcastheadline}` : this.headline,
      interaction_type,
      ...additionalInfo
    };
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: trackingDetails,
        bubbles: true,
        composed: true
      })
    );
  }
  _togglePlay(evt) {
    this._playlist.querySelector(".loading")?.classList.remove("loading");
    this._plyr.elements.buttons.play[0].classList.remove("loading");
    const activeLiElement = evt.currentTarget.closest("li");
    evt.stopImmediatePropagation();
    if (typeof activeLiElement.dataset.active === "undefined") {
      if (typeof this._playingElement?.dataset.active !== "undefined") {
        this._playingElement.removeAttribute("data-active");
        this._playingElement.removeAttribute("data-playing");
        const prog = this._playingElement.querySelector("input[type=range]");
        prog.removeEventListener("input", this._progressSliderChange);
        prog.removeEventListener("mousedown", this._progressSliderMouseDown.bind(this));
        prog.removeEventListener("mouseup", this._progressSliderMouseUp.bind(this));
        prog.removeEventListener("touchstart", this._progressSliderMouseDown.bind(this));
        prog.removeEventListener("touchend", this._progressSliderMouseUp.bind(this));
      }
      this._playingElement = activeLiElement;
      this._playingElement.dataset.active = "";
      const newProg = this._playingElement.querySelector("input[type=range]");
      newProg.addEventListener("input", this._progressSliderChange);
      newProg.addEventListener("mousedown", this._progressSliderMouseDown.bind(this));
      newProg.addEventListener("mouseup", this._progressSliderMouseUp.bind(this));
      newProg.addEventListener("touchstart", this._progressSliderMouseDown.bind(this));
      newProg.addEventListener("touchend", this._progressSliderMouseUp.bind(this));
      this._playingUrl = this._playingElement.dataset.podcasturl;
      this._plyr.source = {
        type: "audio",
        title: this._playingElement.dataset.podcastheadline,
        sources: [{ src: this._playingUrl, type: "audio/mp3" }]
      };
      this._plyr.once("canplay", () => {
        this._plyr.play();
      });
      this._plyr.elements.container.style.setProperty("--podcastdate", `"${this._playingElement.dataset.podcastdate}"`);
      this._plyr.elements.container.style.setProperty(
        "--podcastduration",
        `"${this._playingElement.dataset.podcastduration}"`
      );
      this.style.setProperty("--playerheight", this._plyr.elements.container.offsetHeight + "px");
      this._sendTracking("start", {
        file_type: this._playingUrl.split(".").pop(),
        file_progress: "start",
        time_elapsed: 0
      });
    } else {
      this._plyr.togglePlay();
    }
  }
  _trackAccordionToggle(evt) {
    const current = evt.currentTarget.parentElement;
    if (current.getAttribute("open") === null) {
      this._sendTracking("expand", {
        file_name: `${this.headline}: ${current.parentElement.dataset.podcastheadline}`
      });
    }
  }
  _trackSubscription(evt) {
    evt.stopImmediatePropagation();
    this._sendTracking("subscribe", {
      interaction_text: evt.detail.linkTag.title,
      interaction_result: evt.detail.linkTag.href
    });
  }
  render() {
    return ke`
      <div ?data-playeropen=${this._playingUrl !== ""}>
        <header class="${Rt({ scrolledtop: this._isScrolledTop, main: true })}">
          <jb-picture
            .alt=${this.image.alt}
            .imgData=${this.image.imgData}
            aspect="aspect_1by1"
          ></jb-picture>
          <div>
            <h2>${this.headline}</h2>
            <p>${ae(this.subline)}</p>
          </div>
        </header>

        <ul class="playlist">
          ${this.episodes.map(
      (episode) => ke`
              <li
                data-podcasturl="${episode.url}"
                data-podcastheadline="${episode.headline}"
                data-podcastdate="${episode.date}"
                data-podcastduration="${episode.duration} ${episode.minuteLabel}"
              >
                <details>
                  <summary @click=${this._trackAccordionToggle}>
                    <div class="info">
                      <div class="date">${episode.date}</div>
                      <div class="headline">${ae(episode.headline)}</div>
                    </div>
                    <div class="control">
                      <div class="date">${episode.date}</div>
                      <div class="progress">
                        <input
                          data-plyr="seek"
                          type="range"
                          min="0"
                          max="100"
                          step="0.01"
                          value="0"
                          aria-label="${this.ariaLabelSeek ?? "Seek"}"
                          style="--value: 0%"
                        />
                      </div>
                      <div class="duration">${episode.duration} ${episode.minuteLabel}</div>
                      <button
                        aria-label="${this.ariaLabelPlay ?? "Play"}"
                        aria-pressed="false"
                        class="playbackbutton"
                        @click=${this._togglePlay}
                      >
                        <div class="isplaying">${this._pauseIcon}</div>
                        <div class="ispaused">${this._playIcon}</div>
                      </button>
                      <div class="accordiontoggle">
                        <svg
                          viewBox="0 0 18 18"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.3013 8.41088C12.6273 8.73626 12.6272 9.26376 12.3013 9.58911L6.82477 15.056C6.49884 15.3813 5.9704 15.3814 5.64445 15.056C5.31849 14.7306 5.31852 14.2031 5.64445 13.8777L10.5308 9L5.64445 4.12225C5.31849 3.79688 5.31852 3.26937 5.64445 2.94402C5.97038 2.61867 6.49881 2.61864 6.82477 2.94402L12.3013 8.41088Z"
                          />
                        </svg>
                      </div>
                    </div>
                  </summary>
                </details>
                <div class="description"><div>${ae(episode.text)}</div></div>
              </li>
            `
    )}
        </ul>
        <div class="bottom">
          <div
            id="player"
            class="${Rt({ scrolledbottom: !this._isScrolledBottom })}"
          >
            <audio controls>
              <source
                .src=${this._playingUrl}
                type="audio/mp3"
              />
            </audio>
          </div>
          <footer>
            <span>${this.allEpisodesText}</span>
            <ul @jb-link:clicked=${this._trackSubscription}>
              ${this.providerBadges.map((providerBadge) => {
      const listElement = document.createElement("li");
      const link = document.createElement("a");
      link.setAttribute("title", providerBadge.name);
      const img = document.createElement("jb-picture");
      img.setAttribute("imgData", JSON.stringify(providerBadge.badgeImage.imgData));
      img.setAttribute("alt", providerBadge.name);
      setLink(link, providerBadge.link);
      link.appendChild(img);
      listElement.appendChild(link);
      return listElement;
    })}
            </ul>
          </footer>
        </div>
      </div>
    `;
  }
};
JbPodcastPlayer.styles = r([simple_scrollbar_default, plyr_default, jb_podcast_player_default]);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "allEpisodesText", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "ariaLabelMute", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "ariaLabelPause", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "ariaLabelPlay", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "ariaLabelSeek", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "ariaLabelVolume", 2);
__decorateClass([
  n({ type: Array })
], JbPodcastPlayer.prototype, "episodes", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbPodcastPlayer.prototype, "image", 2);
__decorateClass([
  n({ type: Array })
], JbPodcastPlayer.prototype, "providerBadges", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "subline", 2);
__decorateClass([
  e("audio")
], JbPodcastPlayer.prototype, "_audioPlayer", 2);
__decorateClass([
  r2()
], JbPodcastPlayer.prototype, "_currentProgress", 2);
__decorateClass([
  r2()
], JbPodcastPlayer.prototype, "_isScrolledBottom", 2);
__decorateClass([
  r2()
], JbPodcastPlayer.prototype, "_isScrolledTop", 2);
__decorateClass([
  r2()
], JbPodcastPlayer.prototype, "_playerOpen", 2);
__decorateClass([
  r2()
], JbPodcastPlayer.prototype, "_playingUrl", 2);
__decorateClass([
  e(".playlist")
], JbPodcastPlayer.prototype, "_playlist", 2);
JbPodcastPlayer = __decorateClass([
  customElement("jb-podcast-player")
], JbPodcastPlayer);

export {
  JbPodcastPlayer
};
